"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ComparisonDataDisplay = require("../ComparisonDataDisplay.styled");
var _SpecContent = _interopRequireDefault(require("./SpecContent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SpecBoxContentData = _ref => {
  let {
    spec,
    productId,
    value,
    applyShowDifferences,
    label
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.DataEntryWrapperItem, {
    group: spec.label
  }, /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.ExpandingWrapper, null, /*#__PURE__*/_react.default.createElement(_SpecContent.default, {
    label: label,
    value: value,
    productId: productId,
    applyShowDifferences: applyShowDifferences
  })));
};
var _default = SpecBoxContentData;
exports.default = _default;